
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30.91 11.65"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 11.46L4.4-.01h1.63l4.69 11.46H8.99L7.65 7.99H2.87l-1.22 3.47zm3.31-4.71h3.88l-1.2-3.17q-.54-1.44-.81-2.37a15 15 0 01-.59 2.18zM11.74 11.46v-8.3H13v1.26a3.43 3.43 0 01.9-1.17 1.6 1.6 0 01.9-.28 2.75 2.75 0 011.44.45l-.48 1.31a2 2 0 00-1-.31 1.38 1.38 0 00-.83.28 1.42 1.42 0 00-.52.77 5.05 5.05 0 00-.24 1.64v4.35zM17.09 1.67V-.01h1.4v1.68zm0 9.84V3.16h1.4v8.3zM26.05 10.43a5.17 5.17 0 01-1.51.94 4.56 4.56 0 01-1.55.27 3 3 0 01-2.1-.65 2.23 2.23 0 01-.73-1.71 2.27 2.27 0 011-1.92 3 3 0 011-.46 8.73 8.73 0 011.26-.22 12 12 0 002.51-.48v-.38a1.54 1.54 0 00-.4-1.21 2.31 2.31 0 00-1.6-.47 2.52 2.52 0 00-1.47.34 2.26 2.26 0 00-.69 1.19l-1.37-.18a3.28 3.28 0 01.62-1.43 2.77 2.77 0 011.24-.84 5.73 5.73 0 011.88-.29 4.84 4.84 0 011.73.25 2.34 2.34 0 011 .63 2.15 2.15 0 01.44 1 8 8 0 01.07 1.29v1.89a20.49 20.49 0 00.09 2.48 3 3 0 00.36 1h-1.5a3 3 0 01-.28-1.04zm-.12-3.14a10.11 10.11 0 01-2.3.53 5.68 5.68 0 00-1.22.28 1.33 1.33 0 00-.56.46 1.14 1.14 0 00-.19.67 1.22 1.22 0 00.42.94 1.87 1.87 0 001.25.37 2.9 2.9 0 001.44-.35 2.1 2.1 0 00.93-1 3.18 3.18 0 00.23-1.4zM29.5 11.46V-.01h1.41v11.47z"}})])
          )
        }
      }
    